// extracted by mini-css-extract-plugin
export default {"tableHeadCell":"TableHeadCell_tableHeadCell__mVQcJ","tableHeadCellButton":"TableHeadCell_tableHeadCellButton__G5by5","icon":"TableHeadCell_icon__JcBce"};